// extracted by mini-css-extract-plugin
export default {"root":"ckgoCsuLX8","section":"mdloy_fXvr","sectionDescription":"oge8TagWaA","button":"VolmrmTdvp","phone":"vGeJzGVusc","paragraph":"lKrcZUrYCN"};